import { createContext, useContext, useEffect, useState } from "react";

const PresenceContext = createContext([]);

export const usePresence = () => useContext(PresenceContext);

export const PresenceProvider = ({ user, children }) => {
  const [onlineUsers, setOnlineUsers] = useState([]);

  useEffect(() => {
    if (!user || !window.Echo) return;

    const channel = window.Echo.join("presence-online")
      .here(users => {
        setOnlineUsers(users);
      })
      .joining(u => {
        setOnlineUsers(prev => [...prev, u]);
      })
      .leaving(u => {
        setOnlineUsers(prev =>
          prev.filter(p => p.id !== u.id)
        );
      });

    return () => {
      window.Echo.leave("presence-online");
    };
  }, [user?.id]);

  return (
    <PresenceContext.Provider value={onlineUsers}>
      {children}
    </PresenceContext.Provider>
  );
};
